// Makes rails translations available

import translations from 'shared/translations'

const detectLocale = () => document.documentElement.lang || 'de'

export const translate = (scope, key) => {
  const locale = detectLocale()
  const localized = translations[locale] || {}
  const scoped = localized[scope] || {}
  return scoped[key] || 'Missing translation: #{l}.#{scope}.#{key}'
}
